import { BuscadorPage } from './../buscador/buscador';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, MenuController } from 'ionic-angular';
import { Consultas } from '../../providers/consultas';
import { VariablesGlobales } from '../../providers/variables-globales';
import { Observable } from "rxjs/Rx";
import { Empresa } from '../../models/empresa.model';
import 'rxjs/add/observable/merge';
import { EmpresaSinglePage } from '../empresa-single/empresa-single';
import { BarrioModel } from '../../models/barrio.model';


@Component({
  selector: 'page-lista-empresas',
  templateUrl: 'lista-empresas.html',
  providers: [ Consultas, VariablesGlobales ]
})
export class ListaEmpresas {
   public idSubCategoria: any;
   public idCiudad: any;
   public nombreSubcategoria: any;
   public empresas: Array<Empresa>;
   public loader: any;
   public empresasBack:Array<Empresa> = new Array<Empresa>();
   readonly id_zona_todos:number = -1;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public consultas: Consultas,
    public global : VariablesGlobales,
    public loadingCtrl: LoadingController,
    public menuController:MenuController) {
    this.idSubCategoria = navParams.get("idSubCategoria");
    this.idCiudad = navParams.get("idCiudad");
    this.nombreSubcategoria = navParams.get("nombreCategoria");
    this.empresas = new Array<Empresa>();
    console.log(this.idCiudad);
    console.log(this.idSubCategoria);

  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  goToEmpresa(empresa){
      this.navCtrl.push(EmpresaSinglePage, {empresa});
  }
  ionViewDidLoad() {
    console.log(this.empresas);
    console.log('ionViewDidLoad Listaempresas');
  }

  ngOnInit() {
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
      this.consultas.getEmpresas(this.idCiudad,this.idSubCategoria).subscribe(
        data =>{
          console.log(data);
          this.empresas = data;
          this.loader.dismiss();
          if(this.empresas.length == 1){
            this.goToEmpresa(this.empresas[0]);
          }
        },
        error => {
          console.log(error);
          this.loader.dismiss();
        },
        () => console.log(this.empresas)
      );
  });
  }

  filter(id_empresa_zona:number){
    this.empresas = [];
    this.empresas = this.empresas.concat(this.empresasBack);
    this.empresasBack = [];
    this.empresasBack = this.empresasBack.concat(this.empresas);
    if(id_empresa_zona != this.id_zona_todos){
      this.empresas = this.empresas.filter(x=>x.id_empresa_zona == id_empresa_zona);
    }
  }
  openMenu() {
    this.menuController.open();
  }

}



// WEBPACK FOOTER //
// ./src/pages/lista-empresas/lista-empresas.ts